import axios from "../services/api/api";

export const FETCH_TEACHER_INFORMATION_BEGIN =
  "FETCH_TEACHER_INFORMATION_BEGIN";
export const FETCH_TEACHER_INFORMATION_FULFILLED =
  "FETCH_TEACHER_INFORMATION_FULFILLED";
export const FETCH_TEACHER_INFORMATION_REJECTED =
  "FETCH_TEACHER_INFORMATION_REJECTED";

export function fetchTeacherStudentsAction() {
  return function (dispatch) {
    dispatch({
      type: "FETCH_TEACHER_STUDENTS_BEGIN",
      payload: { loading: true },
    });

    var email = localStorage.getItem("email");

    if (localStorage.getItem("email")) {
      axios
        .get(
          "/Teacher/Students?teacherEmail=" +
            encodeURIComponent(email) +
            "&showActiveOnly=false",
        )
        .then((response) => {
          dispatch({
            type: "FETCH_TEACHER_STUDENTS_SUCCESS",
            payload: response.data.result,
          });
        })
        .catch((err) => {
          dispatch({ type: "FETCH_TEACHER_REJECTED", payload: err });
        });
    }
  };
}

export function fetchTeacherInformation() {
  return function (dispatch) {
    dispatch({
      type: FETCH_TEACHER_INFORMATION_BEGIN,
      payload: { loading: true },
    });

    return new Promise((resolve, reject) => {
      axios
        .get("/Teacher/ByEmail")
        .then((response) => {
          if (typeof response !== "undefined") {
            if (response.data.result.programmes) {
              localStorage.setItem(
                "schoolName",
                response.data.result.customer.name,
              );

              localStorage.setItem(
                "school",
                JSON.stringify(response.data.result.customer),
              );
            }

            dispatch({
              type: FETCH_TEACHER_INFORMATION_FULFILLED,
              payload: response.data.result,
            });
            resolve(true);
          }
        })
        .catch((err) => {
          dispatch({
            type: FETCH_TEACHER_INFORMATION_REJECTED,
            payload: err,
          });
          reject(err);
        });
    });
  };
}
export function addClass(newClass, programid) {
  return {
    type: "ADD_CLASS",
    payload: { newClass, programid },
  };
}
export function deleteClass(classid) {
  return {
    type: "DELETE_CLASS",
    payload: { classid },
  };
}
export function updateClass(updateClass) {
  return {
    type: "UPDATE_CLASS",
    payload: { updateClass },
  };
}
export function addStudent(newStudent, classid) {
  return {
    type: "ADD_STUDENT",
    payload: { newStudent, classid },
  };
}
export function updateStudent(student) {
  return {
    type: "UPDATE_TEACHER_STUDENT",
    payload: { student },
  };
}
